import { FacettenOptionInfo } from '../services/facetten/facetten-option-info';

/**
 * Repräsentation der Kosten aus dem Backend
 */
export enum Kosten {
  KEINE_ANGABE = 'KEINE_ANGABE',
  BIS_500_EUR = 'BIS_500_EUR',
  UEBER_500_BIS_1000_EUR = 'UEBER_500_BIS_1000_EUR',
  UEBER_1000_BIS_5000_EUR = 'UEBER_1000_BIS_5000_EUR',
  UEBER_5000_BIS_10000_EUR = 'UEBER_5000_BIS_10000_EUR',
  UEBER_10000_EUR = 'UEBER_10000_EUR',
  PREISVERHANDELTE_MASSNAHME = 'PREISVERHANDELTE_MASSNAHME'
}

/**
 * backendId ist die ID die zwischen unseren UI und unseren Backend gesendet wird.
 */
export type KostenBezeichnungWithBoundary = FacettenOptionInfo & {
  min: number;
  backendId: Kosten;
  ariaLabel: string;
};

export const kostenBezeichnungWithBoundary: KostenBezeichnungWithBoundary[] = [
  {
    id: '-1',
    backendId: Kosten.PREISVERHANDELTE_MASSNAHME,
    bezeichnung: '',
    ariaLabel: '',
    min: -1
  },
  {
    id: '0',
    backendId: Kosten.KEINE_ANGABE,
    bezeichnung: 'Keine Angabe',
    ariaLabel: 'Keine Angabe',
    min: Infinity
  },
  {
    id: '1',
    backendId: Kosten.BIS_500_EUR,
    bezeichnung: '0 - 500',
    ariaLabel: 'Null bis fünfhundert Euro',
    min: 0
  },
  {
    id: '2',
    backendId: Kosten.UEBER_500_BIS_1000_EUR,
    bezeichnung: '500 - 1.000',
    ariaLabel: 'Fünfhundert bis eintausend Euro',
    min: 500
  },
  {
    id: '3',
    backendId: Kosten.UEBER_1000_BIS_5000_EUR,
    bezeichnung: '1.000 - 5.000',
    ariaLabel: 'Eintausend bis fünftausend Euro',
    min: 1000
  },
  {
    id: '4',
    backendId: Kosten.UEBER_5000_BIS_10000_EUR,
    bezeichnung: '5.000 - 10.000',
    ariaLabel: 'Fünftausend bis zehntausend Euro',
    min: 5000
  },
  {
    id: '5',
    backendId: Kosten.UEBER_10000_EUR,
    bezeichnung: '10.000 +',
    ariaLabel: 'mehr als zehntausend Euro',
    min: 10000
  }
];

/**
 * Ordnet einem Label den Integrationstyp über den key zu
 * Mappt Systematik auf Anzeigetexte
 */
export const orderedKostenBezeichnung: KostenBezeichnungWithBoundary[] =
  kostenBezeichnungWithBoundary.map((item) => ({
    ...item,
    bezeichnung: item.id == '0' ? item.bezeichnung : `${item.bezeichnung} EUR`
  }));

export const getKostenKurzbezeichnungWithBoundary = (id: Kosten): KostenBezeichnungWithBoundary =>
  kostenBezeichnungWithBoundary.find((item) => item.backendId === id)!;
